import React from 'react';
import { Sparkles, Brain, Target, Flame } from 'lucide-react';
import { UIStrings } from '../constants/translations';

interface ChatWelcomeProps {
  userName?: string;
  valuesCount: number;
  goalsCount: number;
  entriesCount: number;
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
  translations: UIStrings;
}

const ChatWelcome: React.FC<ChatWelcomeProps> = ({
  userName,
  valuesCount,
  goalsCount,
  entriesCount,
  suggestions,
  onSuggestionClick,
  translations
}) => {
  const firstName = userName?.split(' ')[0] || '';
  const t = translations.chatWelcome;

  return (
    <div className="py-6 space-y-8 animate-in fade-in duration-700">
      <div className="px-1">
        <h1 className="text-[26px] font-black tracking-tight leading-tight text-black">
          {firstName ? `${firstName},` : `${t.greetingSubtitle}`}<br/>
          <span className="text-black/35">{t.greeting}</span>
        </h1>
        
        <p className="text-[14px] text-black/45 mt-4 leading-relaxed">
          {t.description}
        </p>
      </div>

      {suggestions.length > 0 && (
        <div className="space-y-2">
          <p className="text-[9px] font-bold text-black/20 uppercase tracking-widest px-1">{t.startHere}</p>
          <div className="space-y-1.5">
            {suggestions.map((suggestion, i) => (
              <div 
                key={i} 
                onClick={() => onSuggestionClick(suggestion)}
                className="px-3 py-2.5 bg-white/70 rounded-xl border border-black/[0.03] cursor-pointer hover:bg-white hover:border-indigo-100 hover:shadow-sm transition-all group active:scale-[0.98]"
              >
                <div className="flex items-center gap-2.5">
                  <div className="w-1.5 h-1.5 rounded-full bg-indigo-200 group-hover:bg-indigo-500 transition-colors shrink-0" />
                  <span className="text-[12px] text-black/50 group-hover:text-black/70 transition-colors leading-snug">{suggestion}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatWelcome;